import {
  deleteBudgetFund,
  deleteBudgetFundItem,
  getBudgetFundItemList,
  getBudgetFundList,
  getBudgetFundSettingList,
  getFundExportCode,
  getFundExportResult,
  getFundRecordList,
  saveBudgetFund,
  saveBudgetFundItem,
  saveSplitFundAmount,
  updateBudgetFundAmount,
  updateBudgetFundStatus,
} from '../services';

export default {
  namespace: 'fundBudget',
  state: {},
  effects: {
    *getBudgetFundList({ payload }, { call }) {
      return yield call(getBudgetFundList, payload);
    },
    *getBudgetFundItemList({ payload }, { call }) {
      return yield call(getBudgetFundItemList, payload);
    },
    *getBudgetFundSettingList({ payload }, { call }) {
      return yield call(getBudgetFundSettingList, payload);
    },
    *saveBudgetFund({ payload }, { call }) {
      return yield call(saveBudgetFund, payload);
    },
    *saveBudgetFundItem({ payload }, { call }) {
      return yield call(saveBudgetFundItem, payload);
    },
    *deleteBudgetFund({ payload }, { call }) {
      return yield call(deleteBudgetFund, payload);
    },
    *deleteBudgetFundItem({ payload }, { call }) {
      return yield call(deleteBudgetFundItem, payload);
    },
    // 修改包干经费可用金额
    *updateBudgetFundAmount({ payload }, { call }) {
      return yield call(updateBudgetFundAmount, payload);
    },
    // 拆分金额保存/修改
    *saveSplitFundAmount({ payload }, { call }) {
      return yield call(saveSplitFundAmount, payload);
    },
    // 查询历史记录
    *getFundRecordList({ payload }, { call }) {
      return yield call(getFundRecordList, payload);
    },
    // 导出经费获取code
    *getFundExportCode({ payload }, { call }) {
      return yield call(getFundExportCode, payload);
    },
    // 获取导出结果
    *getFundExportResult({ payload }, { call }) {
      return yield call(getFundExportResult, payload);
    },
    // 修改已生效/废弃状态
    *updateBudgetFundStatus({ payload }, { call }) {
      return yield call(updateBudgetFundStatus, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
